export default __webpack_public_path__ + "static/media/thumb07_newsletter@2x.963e8cbd.png";